import type {AppConfig} from './config.types'
import {Inject, Injectable} from '@angular/core'
import {APP_CONFIG_TOKEN} from '../../../../server/config'
import {Logger} from '../logging/logger'
import {addBreadcrumb, captureException} from '@sentry/angular-ivy'
import {defaultConfig} from './config.types'

@Injectable({providedIn: 'root'})
export class ConfigService {
  readonly config: AppConfig

  constructor(@Inject(APP_CONFIG_TOKEN) injectedConfig: AppConfig) {
    this.config = injectedConfig
  }

  static async loadConfig(): Promise<AppConfig> {
    try {
      Logger.debug('Configuration loading from remote')
      const res = await fetch('/config.json')
      if (res.status >= 200 && res.status < 300) {
        const json = await res.json()
        return json
      } else {
        const body = await res.text()
        addBreadcrumb({level: 'error', message: body})
        captureException(new Error(`Could not fetch config.json`))
        return defaultConfig
      }
    } catch (err) {
      captureException(new Error(`Could not properly configure application, err: ${err.msg || err}`))
      // could not find the config, this is a fatal error
      // still provide a default object so that we can trigger error reporting when sentry is set up
      return defaultConfig
    }
  }

  isProduction(): boolean {
    return this.config.stage === 'prod'
  }
}
